/**
 * @date 2022-01-24 14:10:39
 * @description 202200209版本【业务拓展需要新增会场收品，内含：活动报名和活动管理两个模块】
 * @param 活动报名和活动管理
 * @returns 会场收品【活动列表和收品池列表融合的双table】
 */
import React, { useState } from 'react';
import { Radio } from 'antd';
import classnames from 'classnames';
import { debounce } from 'lodash';
import { getQuery } from '@/common/utils';
import ActivityJoinAndManage from './components/activity-join-and-manage';
import { ActivityReceiptContext } from './activity-receipt-context';
import { ACTIVITYRECEIPTTYPEENUM } from './activity-receipt-config';
import { isInC2B } from '@/common/utils/beInectedIn';
import './index.less';

export default function ActivityReceipt(props) {
  const [activeTab, setActiveTab] = useState(() =>
    getQuery('tab') === '2' ? ACTIVITYRECEIPTTYPEENUM.MANAGE.key : ACTIVITYRECEIPTTYPEENUM.APPLY.key
  );
  //初始化默认选中`活动报名`
  function switchType(curKey) {
    if (curKey !== activeTab) {
      setActiveTab(curKey);
    }
  }

  return (
    <ActivityReceiptContext.Provider value={[activeTab]}>
      <div className="activity-receipt-container">
        {!isInC2B() && (
          <div className="activity-receipt-type-fa">
            {/* <div className="activity-receipt-types">
            {ACTIVITYRECEIPTTYPEENUM &&
              Object.values(ACTIVITYRECEIPTTYPEENUM)?.map((item) => {
                return (
                  <span
                    key={item.key}
                    className={classnames(
                      item.key === activeTab ? 'receipt-type-item-choosed' : '',
                      'receipt-type-item'
                    )}
                    onClick={debounce(() => switchType(item.key), 200)}
                  >
                    {item.name}
                  </span>
                );
              })}
          </div> */}
            <Radio.Group value={activeTab} onChange={(e) => switchType(e.target.value)}>
              {ACTIVITYRECEIPTTYPEENUM &&
                Object.values(ACTIVITYRECEIPTTYPEENUM)?.map((item) => (
                  <Radio.Button
                    key={item.key}
                    value={item.key}
                    style={{ borderRadius: item.key === 'APPLY' ? '4px 0 0 4px' : '0 4px 4px 0' }}
                  >
                    {item.name}
                  </Radio.Button>
                ))}
            </Radio.Group>
          </div>
        )}
        <ActivityJoinAndManage />
      </div>
    </ActivityReceiptContext.Provider>
  );
}
